import { useState, useContext, useEffect } from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import ProductsList from './components/ProductsList.jsx';
import ProductCoilSetting from './components/ProductCoilSetting.jsx';
import { StorefrontProvider, StorefrontContext } from './store/StorefrontContext.jsx';
import { ProductSelectProvider } from './store/ProductSelectContext.jsx';
import BannerCarousel from './components/BannerCarousel.jsx';
import { Button } from 'react-bootstrap';
import RefetchButton from './components/RefetchButton.jsx';
import { ProductCoilSettingProvider } from './store/ProductCoilSettingContext.jsx';
import * as Sentry from "@sentry/react";
import InfoStrip from './components/InfoStrip.jsx';

const storefrontApiClient = new ApolloClient({
  cache: new InMemoryCache(),
  headers: {

    'X-Shopify-Storefront-Access-Token':
      '690caa9d9d9e1eafc54d8091cc5ff079',
  },
});

const App = () => {
  const { state: storefrontStateObject, fetchMetaObject } = useContext(StorefrontContext);
  const [showCoilSettings, setShowCoilSettings] = useState(false);
  const [clickCount, setClickCount] = useState(0);
  const [clickTimeout, setClickTimeout] = useState(null);

  const handleCoilSettingClick = () => {
    setClickCount(prevCount => {
      const newCount = prevCount + 1;
      console.log('CoilSettingClick', newCount);
      if (newCount === 7) {
        setShowCoilSettings(true);
        clearTimeout(clickTimeout);
        return 0; // Reset click count after 3 clicks
      }
      return newCount;
    });

    // Reset click count after 3 seconds
    if (clickTimeout) {
      console.log('count cleared, clickTimeout', clickTimeout);
      clearTimeout(clickTimeout);
    }
    setClickTimeout(setTimeout(() => {
      console.log('count cleared');
      setClickCount(0);
    }, 500));

  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setShowCoilSettings(true);
  //   }, 3000);
  // }, []);

  return (
    <ApolloProvider client={storefrontApiClient}>
      <ProductCoilSettingProvider>
        <StorefrontProvider>
          <ProductSelectProvider>
            {
              showCoilSettings ?
                <ProductCoilSetting /> :
                <>
                  <InfoStrip />
                  <BannerCarousel />
                  <ProductsList />
                </>
            }
            <div className="d-none" >
              <RefetchButton />
              <Button
                style={{
                  ...{
                    position: 'fixed',
                    bottom: '10px',
                    right: '10px',
                    padding: '10px',
                    fontSize: '20px',
                    color: 'white',
                    backgroundColor: 'red',
                    borderRadius: '10px',
                    border: 'none',
                    cursor: 'pointer',
                  }, ...(!showCoilSettings ? { backgroundColor: 'transparent' } : { backgroundColor: 'red' })

                }}
                // onClick={() => {
                //   setShowCoilSettings(!showCoilSettings);
                // }}
                className={!showCoilSettings ? 'btn-show-coil' : 'btn-back'}
                onClick={() => {
                  !showCoilSettings ?
                    handleCoilSettingClick() :
                    setShowCoilSettings(false)
                }}
              >
                {showCoilSettings ? 'Back to Products' : 'Coil Settings'}
              </Button>
            </div>
          </ProductSelectProvider>
        </StorefrontProvider>
      </ProductCoilSettingProvider>
    </ApolloProvider >
  );
};

export default Sentry.withProfiler(App);